import styled from 'styled-components'
import lock from './lock.png'

export default styled.div`
  width: 13px;
  height: 17px;
  background: url(${lock}) no-repeat;
  background-size: 13px 17px;
`
